var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.33 11.943c.244.243.64.243.884 0l3.513-3.512a.63.63 0 0 0 .077-.79l-.077-.094-3.513-3.513a.625.625 0 0 0-.884.885l2.445 2.444H3.7a.625.625 0 0 0 0 1.25h7.076L8.33 11.06a.626.626 0 0 0 0 .884"
  })));
};
export default SvgArrowRight;